import React, { useCallback, useState } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { HomeStack } from "./home-summary-stack";
import { MoreSummaryStack } from "./more-summary-stack";
import { ThemeType } from "../../theme/theme";
import { useTheme } from "react-native-paper";
import { ServiceSummaryStack } from "./service-summary-stack";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { StorageKeys } from "../../enums/storage-keys";
import * as storage from "../../utils/storage";
import { useFocusEffect } from "@react-navigation/native";
import { RewardIntroStack } from "./reward-intro-stack";

const Stack = createStackNavigator();

/**
 * These are the three screens with tabs in them
 */
export const SummaryStack = () => {
  const theme = useTheme() as ThemeType;
  const allowServiceRequests = useSelector(
    (state: RootState) => state.service.allowServiceRequests
  );
  const [allowServiceRequestsStorage, setAllowServiceRequestsStorage] = useState<any>();
  const isServiceRequestsTabVisible = allowServiceRequests || allowServiceRequestsStorage;
  const appMode = useSelector((state: RootState) => state.reservation.appMode);

  const layoutEffect = useCallback(() => {
    (async () => {
      const allowSR = await storage.load(StorageKeys.ALLOW_SERVICE_REQUESTS);
      setAllowServiceRequestsStorage(allowSR);
    })();
  }, []);
  useFocusEffect(layoutEffect);

  return (
    <Stack.Navigator
      initialRouteName="RewardIntroStack"
      screenOptions={{ headerMode: "screen", showFullMenu: true }}
      keyboardHidesNavigationBar
      activeColor={theme.colors.darkBg}
      inActiveColor={theme.colors.darkBg}
      barStyle={{ backgroundColor: theme.colors.white }}>
      <Stack.Screen
        name="RewardIntroStack"
        component={RewardIntroStack}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="Reservation"
        component={HomeStack(appMode)}
        options={{ headerShown: false }}
      />
      {isServiceRequestsTabVisible && (
        <Stack.Screen name="Service Request" component={ServiceSummaryStack} options={{}} />
      )}
      <Stack.Screen name="More" component={MoreSummaryStack} options={{ headerShown: false }} />
    </Stack.Navigator>
  );
};

export interface SummaryParamsList extends Record<string, any> {}

export type SummaryScreenProps = {
  route: { name: string; key: string; params: SummaryParamsList };
};
